@if (userCanUsePrepayment() && userHasABalanceAccount()) {
  @if (orderValidate()) {
    <div>
      <div class="mx-auto mb-3 max-w-md px-5 lg:max-w-full lg:px-0">
        <div
          class="space-y-5 rounded-md md:border md:border-neutral-300 md:px-4.5 md:py-5"
          [style.color]="headingColor() | contentBuilderColor"
        >
          <div class="flex items-center justify-between">
            <div class="flex flex-1 items-center">
              <span class="font-accent font-bold text-2xl">{{
                'cart-prepayment-block.title' | translate
              }}</span>
            </div>
            <div>
              <app-button-atom
                [label]="'cart-prepayment-block.recharge-account' | translate"
                [type]="'outlined'"
                [color]="'neutral'"
                [size]="'XS'"
                [thickSize]="'XS'"
                [icon]="'icon-handout'"
                (click)="openTopUpModal()"
              />
            </div>
          </div>
          <div class="flex items-center justify-between">
            <p>{{ 'cart-prepayment-block.use-balance' | translate }}</p>
            <app-toggle-switch-atom
              [checked]="isPrepaymentEnabled()"
              (checkedChange)="onToggleChange($event)"
            />
          </div>
          <div class="flex items-center justify-between">
            <p>{{ 'cart-prepayment-block.balance-before-order' | translate }}</p>
            <p>
              @if (isLoading()) {
                <img
                  src="assets/images/spinner.svg"
                  alt=""
                />
              } @else {
                <app-price-atom
                  [amount]="orderBalanceBeforeOrder() ?? 0"
                  [format]="true"
                  [bold]="false"
                />
              }
            </p>
          </div>
          <div class="flex items-center justify-between">
            <p>{{ 'cart-prepayment-block.balance-after-order' | translate }}</p>
            <p>
              <app-price-atom
                [amount]="orderBalanceAfterOrder() ?? 0"
                [format]="true"
                [bold]="false"
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  }
}
